{
  "name": "rocket-capture-frontend",
  "version": "5.100.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --hmr",
    "start:no-hmr": "ng serve",
    "build": "ng build && node scripts/build-info.mjs",
    "test": "ng test --no-watch --no-progress --code-coverage",
    "test:dev": "ng test --code-coverage --karma-config=karma.conf.dev.js",
    "lint": "ng lint",
    "lint-staged": "lint-staged -v",
    "prepare": "husky install",
    "pre-commit": "lint-staged && ng lint",
    "sonar": "sonar-scanner-npm",
    "audit:viewports": "node scripts/audit-viewports.mjs",
    "test:scripts": "node --test scripts/*.test.mjs",
    "lint-scss": "stylelint src/**/*.scss --fix",
    "prettier": "prettier --write src/**/*.{ts,scss}"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.2.4",
    "@angular/common": "^22.2.4",
    "@angular/compiler": "^22.2.4",
    "@angular/core": "^22.2.4",
    "@angular/forms": "^22.2.4",
    "@angular/localize": "^22.2.4",
    "@angular/platform-browser": "^22.2.4",
    "@angular/platform-browser-dynamic": "^22.2.4",
    "@angular/router": "^22.2.4",
    "@docuseal/angular": "^1.0.30",
    "@ng-bootstrap/ng-bootstrap": "^21.0.0",
    "@ng-select/ng-select": "^23.11.0",
    "@ngx-formly/core": "^6.3.6",
    "@popperjs/core": "^2.11.8",
    "@rocketfinancialcorp/rocket-ui": "^3.1.0",
    "@sentry/angular": "^11.10.0",
    "@sentry/cli": "^2.33.0",
    "@siemens/ngx-datatable": "^27.1.0",
    "@types/google.maps": "^3.55.12",
    "crypto-es": "^2.1.0",
    "date-fns": "^3.6.0",
    "date-fns-tz": "^3.1.3",
    "flag-icons": "7.2.3",
    "heic2any": "^0.0.4",
    "libphonenumber-js": "^1.11.5",
    "lodash-es": "^4.17.21",
    "ngx-extended-pdf-viewer": "^28.1.2",
    "ngx-mask": "^22.2.5",
    "ngx-pagination": "^6.0.3",
    "ngx-toastr": "^20.0.5",
    "persona": "^5.8.0",
    "rxjs": "^7.8.1",
    "stylelint-declaration-strict-value": "^1.9.1",
    "tslib": "^2.6.3",
    "typescript": "6.0.3",
    "uuid": "^10.0.0",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^22.2.5",
    "@angular-eslint/builder": "^22.6.0",
    "@angular-eslint/eslint-plugin": "^22.6.0",
    "@angular-eslint/eslint-plugin-template": "^22.6.0",
    "@angular-eslint/schematics": "^22.6.0",
    "@angular-eslint/template-parser": "^22.6.0",
    "@angular/cli": "^22.2.5",
    "@angular/compiler-cli": "^22.2.4",
    "@angular/language-service": "^22.2.4",
    "@eslint/js": "^9.39.5",
    "@sonar/scan": "5.0.1",
    "@types/jasmine": "~5.1.4",
    "@types/lodash-es": "^4.17.12",
    "@types/node": "^20.14.8",
    "@types/uuid": "^10.0.0",
    "@typescript-eslint/eslint-plugin": "^8.72.1",
    "@typescript-eslint/parser": "^8.72.1",
    "angular-eslint": "^22.6.0",
    "eslint": "^9.39.5",
    "eslint-config-prettier": "^8.8.0",
    "eslint-import-resolver-typescript": "^3.7.0",
    "eslint-plugin-import": "^2.32.0",
    "eslint-plugin-jasmine": "^4.1.3",
    "eslint-plugin-jsdoc": "^50.6.3",
    "eslint-plugin-ngrx": "^2.1.4",
    "eslint-plugin-no-loops": "^0.4.0",
    "eslint-plugin-no-unsanitized": "^4.0.2",
    "eslint-plugin-prefer-arrow": "^1.2.3",
    "eslint-plugin-promise": "^7.3.0",
    "eslint-plugin-regexp": "^3.3.2",
    "husky": "^8.0.2",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "^4.5.0",
    "jasmine-marbles": "^0.9.2",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "karma-sonarqube-unit-reporter": "0.0.23",
    "karma-spec-reporter": "0.0.36",
    "karma-verbose-reporter": "^0.0.8",
    "lint-staged": "^15.2.7",
    "postcss": "^8.4.40",
    "postcss-scss": "^4.0.9",
    "prettier": "^3.3.3",
    "stylelint": "^16.8.1",
    "stylelint-config-prettier": "^9.0.5",
    "stylelint-config-standard": "^36.0.1",
    "stylelint-declaration-strict-value": "^1.10.6",
    "stylelint-prettier": "^5.0.2",
    "stylelint-scss": "^6.4.1",
    "tailwindcss": "^3.4.7",
    "ts-node": "~10.9.2",
    "typescript-eslint": "^8.72.1"
  },
  "browser": {
    "crypto": false
  },
  "lint-staged": {
    "**/*.{json,md,html}": [
      "prettier --write"
    ],
    "**/*.ts": [
      "prettier --write",
      "eslint"
    ],
    "**/*.scss": [
      "prettier --write",
      "npm run lint-scss"
    ]
  }
}
